var map = {
	"./AcesandEights50Hand_en.png": 81268,
	"./AllAmericanPoker50Hand_en.png": 63499,
	"./AmericanBaccarat_en.png": 27322,
	"./Baccarat3HZC_en.png": 26416,
	"./BlackJack3HDoubleExposure_en.png": 12630,
	"./BlackJack3H_en.png": 20786,
	"./BonusDuecesWild50Hand_en.png": 75669,
	"./BonusPoker50Hand_en.png": 76305,
	"./CaribbeanHoldem_en.png": 7425,
	"./CaribbeanStud_en.png": 33536,
	"./DoubleBonusPoker50Hand_en.png": 68316,
	"./DoubleDoubleBonusPoker50Hand_en.png": 27265,
	"./DuecesWild50Hand_en.png": 6714,
	"./EURoulette_en.png": 53679,
	"./JacksorBetter50Hand_en.png": 55834,
	"./JokerPoker50Hand_en.png": 79377,
	"./SG12Zodiacs.png": 39417,
	"./SG5LuckyLions.png": 67645,
	"./SG5Mariachis.png": 62797,
	"./SGAllForOne.png": 16675,
	"./SGArcaneElements.png": 70108,
	"./SGArcticWonders.png": 469,
	"./SGAzlandsGold.png": 7446,
	"./SGBarnstormerBucks.png": 55420,
	"./SGBikiniIsland.png": 76206,
	"./SGBirdOfThunder.png": 86125,
	"./SGBlackbeardsBounty.png": 77512,
	"./SGBombsAway.png": 75120,
	"./SGBuggyBonus.png": 19738,
	"./SGCakeValley.png": 70520,
	"./SGCarnivalCash.png": 9262,
	"./SGCashReef.png": 59514,
	"./SGCashosaurus.png": 344,
	"./SGColossalGems.png": 63589,
	"./SGCoyoteCrash.png": 7457,
	"./SGDiscoFunk.png": 76121,
	"./SGDoubleODollars.png": 30334,
	"./SGDrFeelgood.png": 17792,
	"./SGDragonsRealm.png": 95940,
	"./SGDragonsThrone.png": 66003,
	"./SGEgyptianDreams.png": 41398,
	"./SGEgyptianDreamsDeluxe.png": 74827,
	"./SGFaCaiShen.png": 95625,
	"./SGFaCaiShenDeluxe.png": 98948,
	"./SGFenghuang.png": 39472,
	"./SGFireRooster.png": 68713,
	"./SGFlyingHigh.png": 60700,
	"./SGFortuneDogs.png": 35919,
	"./SGFourDivineBeasts.png": 6816,
	"./SGFrontierFortunes.png": 87856,
	"./SGGalacticCash.png": 67228,
	"./SGGangsters.png": 68113,
	"./SGGlamRock.png": 16953,
	"./SGGoldRush.png": 69941,
	"./SGGoldenUnicorn.png": 56340,
	"./SGGrapeEscape.png": 78445,
	"./SGHappiestChristmasTree.png": 32107,
	"./SGHappyApe.png": 94659,
	"./SGHauntedHouse.png": 40636,
	"./SGHeySushi.png": 51101,
	"./SGHotHotFruit.png": 41121,
	"./SGHotHotHalloween.png": 922,
	"./SGIndianCashCatcher.png": 30373,
	"./SGJellyfishFlow.png": 97039,
	"./SGJellyfishFlowUltra.png": 91025,
	"./SGJugglenaut.png": 42065,
	"./SGJump.png": 2005,
	"./SGJungleRumble.png": 61609,
	"./SGKanesInferno.png": 46890,
	"./SGKingTutsTomb.png": 95224,
	"./SGKnockoutFootball.png": 78602,
	"./SGKnockoutFootballRush.png": 45896,
	"./SGLittleGreenMoney.png": 16762,
	"./SGLondonHunter.png": 45289,
	"./SGLoonyBlox.png": 60731,
	"./SGLuckyFortuneCat.png": 79652,
	"./SGLuckyLucky.png": 64205,
	"./SGMagicOak.png": 1577,
	"./SGMonsterMashCash.png": 27581,
	"./SGMountMazuma.png": 91625,
	"./SGMrBling.png": 58220,
	"./SGMummyMoney.png": 71070,
	"./SGMysticFortune.png": 86927,
	"./SGNaughtySanta.png": 31502,
	"./SGNuwa.png": 75046,
	"./SGOceansCall.png": 11716,
	"./SGPamperMe.png": 94312,
	"./SGPandaPanda.png": 33373,
	"./SGPiratesPlunder.png": 60745,
	"./SGPoolShark.png": 60164,
	"./SGPresto.png": 80344,
	"./SGPuckerUpPrince.png": 39607,
	"./SGPumpkinPatch.png": 38511,
	"./SGQueenOfQueens1024.png": 60528,
	"./SGQueenOfQueens243.png": 21056,
	"./SGRideEmCowboy.png": 44708,
	"./SGRodeoDrive.png": 11452,
	"./SGRollingRoger.png": 10269,
	"./SGRomanEmpire.png": 60946,
	"./SGRuffledUp.png": 19524,
	"./SGSOS.png": 77860,
	"./SGSantasVillage.png": 34103,
	"./SGScopa.png": 95693,
	"./SGScruffyScallywags.png": 51893,
	"./SGShaolinFortunes100.png": 22540,
	"./SGShaolinFortunes243.png": 58488,
	"./SGShogunsLand.png": 52595,
	"./SGSirBlingalot.png": 32555,
	"./SGSkysTheLimit.png": 10761,
	"./SGSpaceFortune.png": 85540,
	"./SGSparta.png": 11412,
	"./SGSuperStrike.png": 73450,
	"./SGSuperTwister.png": 99618,
	"./SGTabernaDeLosMuertos.png": 45130,
	"./SGTabernaDeLosMuertosUltra.png": 91586,
	"./SGTechnoTumble.png": 88733,
	"./SGTheBigDeal.png": 38710,
	"./SGTheDeadEscape.png": 70527,
	"./SGTheDragonCastle.png": 13833,
	"./SGTheKoiGate.png": 22320,
	"./SGTowerOfPizza.png": 37967,
	"./SGTreasureDiver.png": 43476,
	"./SGTreasureTomb.png": 2772,
	"./SGVikingsPlunder.png": 35552,
	"./SGWaysOfFortune.png": 23431,
	"./SGWealthInn.png": 78745,
	"./SGWeirdScience.png": 27366,
	"./SGWickedWitch.png": 38239,
	"./SGWildTrucks.png": 72213,
	"./SGWizardsWantWar.png": 3477,
	"./SGZeus.png": 7510,
	"./SGZeus2.png": 42454,
	"./SicBo.png": 81925,
	"./TGBlackjackAmerican.png": 16128,
	"./TGDragonTiger.png": 46860,
	"./TGThreeCardPoker.png": 22993,
	"./TGThreeCardPokerDeluxe.png": 52524,
	"./TGWar.png": 41360,
	"./TensorBetter50Hand.png": 84058,
	"./game6.png": 83383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24960;